module.exports = __webpack_public_path__ + "img/grid-dark.fc1c0834.svg";